// Cannot use keymirror yet
// todo: remove hand, hand2
export const BAGS_TYPES = {
  HAND: "hand",
  HOLD: "hold",
  HAND2: "hand2",
  STROLLER: "stroller",
  POBEDA: "pobeda",
  CABIN_BAG: "cabin_bag",
  PERSONAL_ITEM: "personal_item",
  HOLD_BAG: "hold_bag",
} as const
